export enum CronBuilderOptionsEnum {
  Daily,
  Weekly,
  MonthlyByDate,
  MonthlyByDayOfTheWeek
}
